import entityReducer from 'syft-acp-core/reducers/generators/entityReducer'
import * as entityTypes from 'syft-acp-core/reducers/generators/entities'

import * as types from './action-types'
import type { WorkerBlockEntity } from './types'

export const reducer = entityReducer<WorkerBlockEntity>(
  'workerBlocks',
  {
    [entityTypes.ENTITIES_FETCH_BEGIN]: types.WORKER_BLOCKS_FETCH_BEGIN,
    [entityTypes.ENTITIES_FETCH_SUCCEEDED]: types.WORKER_BLOCKS_FETCH_SUCCEEDED,
    [entityTypes.ENTITIES_FETCH_FAILED]: types.WORKER_BLOCKS_FETCH_FAILED,
  },
  {
    idKey: 'id',
    localEntityMap: true,
  },
)
